import React from "react";
import {
  ClockIcon,
  PaintBrushIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";

import FeatureGate from "./FeatureGate";

const MediaIcon = () => (
  <svg
    viewBox="0 0 64 64"
    className="h-16 w-16 text-theme-primary"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="8"
      y="14"
      width="48"
      height="36"
      rx="6"
      stroke="currentColor"
      strokeWidth="2"
      className="opacity-80"
    />
    <circle
      cx="22"
      cy="28"
      r="4"
      fill="currentColor"
      className="origin-center animate-pulse opacity-70"
    />
    <path
      d="M12 42l12-10 10 7 8-6 10 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="opacity-90"
    >
      <animate
        attributeName="opacity"
        values="0.55;1;0.55"
        dur="3.5s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
);

const MediaPaywall = () => (
  <FeatureGate
    icon={<MediaIcon />}
    title="Generate images for your site"
    description="Create logos, favicons, social images, and content photos with AI. Keep versions and attach them to tables and pages."
    featureLabel="Media"
    bullets={[
      { icon: PaintBrushIcon, text: "Generate and edit assets in place" },
      { icon: ClockIcon, text: "Version history for every image" },
      { icon: TableCellsIcon, text: "Wire images into your site data" },
    ]}
  />
);

export default MediaPaywall;
